import { Component, OnInit, Inject, NgZone, ChangeDetectorRef } from '@angular/core';
// import * as shaka from 'shaka-player';
import { UserPanelService } from '../user-panel.service';
import { AngularFireAuth } from '@angular/fire/auth'
import { userInfo } from 'os';
import { Md5 } from 'ts-md5/dist/md5';
import { Router } from '@angular/router';
import { $WebSocket, WebSocketConfig } from 'angular2-websocket';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { YouThereDialogComponent } from '../you-there-dialog/you-there-dialog.component'
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnyTxtRecord } from 'dns';
import { Renderer2 } from '@angular/core';
import { LoadingDialogComponent } from '../loading-dialog/loading-dialog.component';
// declare var shaka: any;
declare const chrome: any;
declare const shaka: any;
@Component({
  selector: 'app-clip',
  templateUrl: './clip.component.html',
  styleUrls: ['./clip.component.scss'],
  providers: [Idle, Keepalive]
})
export class ClipComponent implements OnInit {
  manifestUri = '';
  user: any;
  video;
  hasExtension: boolean = false;
  videoPaused = false;
  ws: $WebSocket;
  clipName: string;
  clipNamePretty: string;
  subjectName: any;
  token = '';
  loadingDialog:MatDialogRef<LoadingDialogComponent>;
  constructor(private userPanelService: UserPanelService,
    private auth: AngularFireAuth,
    private router: Router,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    private idle: Idle, private keepalive: Keepalive,
  ) {
    this.loadVisJsScript();
    if (this.getBrowserName() !== 'chrome' && window.location.pathname != '/only-chrome') window.location.href = 'only-chrome'
    document.addEventListener('shaka-ui-load-failed', () => {
      alert("Erro")
    });
    document.addEventListener('shaka-ui-loaded', () => {
      this.auth.onAuthStateChanged(async (userInfo) => {
        this.clipName = userPanelService.clipName;
        if (userInfo != null) {
          if (userPanelService.clipName === null || userPanelService.subjectName === null) {
            router.navigateByUrl('korisnik')
          } else {
            this.user = userInfo;
            var token = await userInfo.getIdToken();
            this.auth.onIdTokenChanged((_token) => {
              console.log(_token)
            })
            alert("Video će se uskoro učitati :)");
            this.ws = new $WebSocket("wss://bbsocket.store:3001", [token, this.clipName.replace(/[ćčžšđ#]/g, ""), userPanelService.subjectName.replace(/ /g, "_").replace(/[ćčžšđ#]/g, "")]);
            this.ws.onOpen(()=>{
              this.manifestUri =
                `https://us-east-1.linodeobjects.com:443/${Md5.hashStr(this.user.uid)}/${userPanelService.subjectName}/${encodeURIComponent(userPanelService.clipName)}/manifest.mpd`;
              this.initApp();
            })
          }
        } else {
          router.navigateByUrl('korisnik')
        }
      })
    });

  }
  loadVisJsScript() {
    console.log('Loading visjs js/css files...');
    let script = document.createElement('script');
    script.src = "assets/js/shaka-player/shaka-player.ui.js";
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(script);
  }
  onOverlayClick() {
    var vidElement: any = document.getElementById('video');
    this.videoPaused = (this.videoPaused) ? false : true;
    if (this.videoPaused) {
      vidElement.pause()
      this.sendMessage("pause", {
        currentSecond: this.video.currentTime
      })
    } else {
      vidElement.play();
      this.sendMessage("play", {
        currentSecond: this.video.currentTime
      })
    }
  }
  onOverlayHover() {
    var vidElement: any = document.getElementById('video');
    vidElement.focus();
  }
  onOverlayLeave() {
    var vidElement: any = document.getElementById('video');
    vidElement.blur();
  }
  ngOnInit() {
    this.loadingDialog = this.dialog.open(LoadingDialogComponent,{
      disableClose:true
    });
  }
  restart() {
  }
  ngOnDestroy() {
    this.idle.stop()
    if (this.ws != undefined) {
      this.sendMessage('componentDestroy', {
        currentSecond: this.video.currentTime
      })
      this.ws.close(true);
    }
  }
  async initApp() {
    // Install built-in polyfills to patch browser incompatibilities.
    shaka.polyfill.installAll();

    // Check to see if the browser supports the basic APIs Shaka needs.
    if (shaka.Player.isBrowserSupported()) {
      // Everything looks good!
      var signatures = await this.userPanelService.getSignatures();
      console.log(signatures)
      if (signatures === "BAD_TOKEN") alert("Greška pri reprodukciji. Kontaktiraj nas.")
      //IF SIGNATURES ALREADY_LOGGED_IN || NOT_LOGGED_IN || BAD_TOKEN
      this.initPlayer(signatures);
    } else {
      // This browser does not have the minimum set of APIs we need.
      console.error('Browser not supported!');
    }
  }

  initPlayer(signatures) {

    // Create a Player instance.
    const video: any = document.getElementById('video');
    console.log(video);
    const config = {
      controlPanelElements: [
        'play_pause',
        'time_and_duration',
        'spacer',
        'mute',
        'volume',
        'fullscreen',
        'overflow_menu',
      ],
      'overflowMenuButtons': [
        'playback_rate',
      ],
      addSeekBar: true,
      addBigPlayButton: false,
      clearBufferOnQualityChange: true,
      showUnbufferedStart: false,
      'seekBarColors': {
        base: 'rgba(255, 64, 129, 0.3)',
        buffered: 'rgba(255, 64, 129, 0.6)',
        played: 'rgba(255, 64, 129, 1)',
      },
      volumeBarColors: {
        base: 'rgba(255, 255, 255, 0.54)',
        level: 'rgb(255, 255, 255)',
      },
      fadeDelay: 0,
      doubleClickForFullscreen: true
    };
    const ui = video['ui'];
    const controls = ui.getControls();
    const player = controls.getLocalPlayer();
    // shaka.log.setLevel(shaka.log.Level.NONE);
    player.configure({
      drm: {
        servers: {
          'org.w3.clearkey': 'https://us-central1-binarybioskop-1551559206895.cloudfunctions.net/drm1'
          // 'org.w3.clearkey': 'http://localhost:5000/binarybioskop-1551559206895/us-central1/drm1'
        }
      }
    });
    player.getNetworkingEngine().registerRequestFilter((type, request) => {
      if (type === 2) {
        request.headers['Authorization'] = `Bearer ${this.token}`;
      }
      if (type === 0)
        request.uris[0] += `?${signatures.mpd}`

      if (type === 1) {
        if (/.*\/(video.mp4)/.test(request.uris[0]))
          request.uris[0] += `?${signatures.video}`
        if (/.*\/(audio.mp4)/.test(request.uris[0]))
          request.uris[0] += `?${signatures.audio}`
      }

    });
    player.addEventListener('error', this.onErrorEvent);
    player.load(this.manifestUri).then(() => {
      this.loadingDialog.close();
      this.video = video;
      // this.idle.onIdleEnd.subscribe(() => console.log('No longer idle.'));
      this.idle.onTimeout.subscribe(() => {
      });
      this.idle.onIdleStart.subscribe(() => {
        this.sendMessage("timeout", {
          currentSecond: this.video.currentTime
        })
        this.video.pause();
        this.dialog.open(YouThereDialogComponent, {
          width: "80%",
          height: "90%",
          disableClose: true
        }).afterClosed().subscribe(code => {
          if (code == 200) {
            this.sendMessage("iAmHere", {
              currentSecond: this.video.currentTime
            })
            this.video.play()
            this.idle.watch();
          }
        })

      });
      // this.idle.onTimeoutWarning.subscribe((countdown) => console.log('You will time out in ' + countdown + ' seconds!'));
      this.idle.setIdle(60*10);
      this.idle.setTimeout(50000000);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idle.watch();
      this.idle.onInterrupt.subscribe((interrupt) => {
        this.sendMessage("returnFromIdle", {
          currentSecond: this.video.currentTime
        })
      })
      this.sendMessage("videoLoaded", {
        clipLength: this.video.duration
      })
      let beforeSeekSecond = 0;
      this.video.onseeking = () => {
        if (this.video.played.length >= 1) {
          beforeSeekSecond = this.video.played.end(this.video.played.length - 1);
        }
      }
      this.video.onseeked = () => {
        this.sendMessage("seek", {
          orig: beforeSeekSecond,
          dest: this.video.currentTime
        })
      };
    }).catch(error => { this.onError(error) });  // onError is executed if the asynchronous load fails.
  }

  initFailed(errorEvent) {
    // Handle the failure to load; errorEvent.detail.reasonCode has a
    // shaka.ui.FailReasonCode describing why.
    console.error('Unable to load the UI library!');
  }

  sendMessage(type, data) {
    this.ws.send(JSON.stringify({
      event: type,
      data: data
    })).subscribe(
      (msg) => {
        ;
      },
      (msg) => {
        console.log("error", msg);
      },
      () => {
      }
    );
  }
  onErrorEvent(event) {
    // Extract the shaka.util.Error object from the event.
    this.onError(event.detail);
  }

  onError(error) {
    // Log the error.
    console.error('Error code', error.code, 'object', error);
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  } p

  makeSubprotocolSafe(subprotocol: string) {
    return subprotocol.replace(/[ćčžšđ#]/g, "")
  }

}